import React from "react";
import { Redirect } from "react-router";
import { ROUTES } from "../../constants";
import useUser from "../../hooks/useUser";

interface Props {
  to?: string;
}

const SignInRedirect: React.FC<Props> = ({ to }) => {
  const { user } = useUser();
  if (!user) {
    return <Redirect to={ROUTES.LOGIN} />;
  }
  return null;
};

export default SignInRedirect;
